var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinPaymentsLogoWhiteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 167,
    height: 41,
    viewBox: "0 0 168.6 40.7",
    style: {
      enableBackground: "new 0 0 168.6 40.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:#1C60DD;enable-background:new    ;}\n\t.st1{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:#1C60DD;enable-background:new    ;}\n\t.st2{opacity:0.9;fill-rule:evenodd;clip-rule:evenodd;fill:#1C60DD;enable-background:new    ;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#C0C9D7;}\n\t.st5{fill:#1C60DD;}\n\t.st6{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st7{opacity:0.2;fill:url(#SVGID_00000064337948869153304940000003641601256663546793_);enable-background:new    ;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#B0B5BE;}\n\t.st9{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,16.8l1.1-4.3l8-4.6v5.8l-9.2,5.7V16.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.9,17l9-5.6V16c0,0-0.1,1.5-0.8,1.8c-0.5,0.2-8.2,4.8-8.2,4.8L3.9,17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.9,19.7l8-4.7v4.6c0,0,0,1.3-0.8,1.7c-0.5,0.3-7.2,4.2-7.2,4.2L8.9,19.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,6.2l4.4-2.8v5.8l-4.4,2.7L12.2,6.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,9.7l4.4-2.6v6l-4.4,2.6L15.8,9.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,1.8l3-1.8v4c0,0,0,2-0.8,2.4c-0.2,0.1-2.2,1.3-2.2,1.3L19.2,1.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.3,13.5l3-1.8l-0.1,4.6c0,0,0.1,1.2-0.8,1.8c-0.2,0.2-2.3,1.2-2.2,1.2C19.3,19.3,19.3,13.4,19.3,13.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,5.6L25.3,4c0,0,0,2.4,0,4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.9,1.2c0,0-1.2,0.8-1.2,0.8 C22.9,11.4,22.8,5.6,22.8,5.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.3,7.9c0,0.1-7.4,3.7-8.5,4.9c0.6-0.5-0.5,0.5-0.6,1.9l0.3,13.4c0,0-0.6,1.8,2.2,3.4 c2,1.1,13.3,8.1,14.7,8.7c1.4,0.7,1.8-0.4,1.8-0.4v-13c0,0,0.4-2.1-2-3.6C16.8,22.8,2.1,16.1,1.5,14C0.8,11.8,9.3,8.4,9.3,7.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.6,26.7l0.7-0.5V40c0,0-0.3,0.7-0.7,0.8C18.5,40.7,18.6,26.7,18.6,26.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1,14.5c0.1,0.2,0.2,0.3,0.3,0.5C1.2,14.8,1,14.6,1,14.5C0.1,12.2,6.4,9.7,9,8c0,0-6.4,3.1-7.6,4.2 c-1.1,1-1.2,1.6-1.2,1.6L0,14.6c0-0.4,0-0.8,0.1-0.8C0.2,13.9,1,14.4,1,14.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.6,23.8c-0.5-0.4-7.1-3.4-11.7-6.1c0.3,0.2,0.5,0.3,0.7,0.4l10.8,21.6c0.2,0.1,0.4,0.2,0.5,0.3l1.6,0.8 V26.8C18.6,26.8,18.7,24.9,16.6,23.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.3772,
    y1: 20.9356,
    x2: 0.3266,
    y2: 12.7691,
    gradientTransform: "matrix(1 0 0 -1 0 41.7409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C60DD",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.5,29.9c-0.2-0.5-0.4-1-0.5-1.6C0,28.8,0.2,29.4,0.5,29.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4.9,17.6c-1.6-1-3-1.9-3.6-2.7c-0.1-0.1-0.2-0.3-0.3-0.5c0-0.1-0.8-0.7-0.8-0.8C0.1,13.8,0,14.2,0,14.6 l0,13.6c0.1,1,0.2,1,0.4,1.6c0.4,0.6,0.6,0.8,1.3,1.5c1.7,1,11.9,6.8,14.7,8.3L5.6,18L4.9,17.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125577949163504455120000004607217106509511096_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.8238,
    y1: 17.9615,
    x2: 3.7735,
    y2: 9.7933,
    gradientTransform: "matrix(1 0 0 -1 0 41.7409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C60DD",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000125577949163504455120000004607217106509511096_)",
      enableBackground: "new"
    },
    d: " M4.9,17.6c-1.6-1-3-1.9-3.6-2.7c-0.1-0.1-0.2-0.3-0.3-0.5c0-0.1-0.8-0.7-0.8-0.8c0,0-0.1,0.6-0.2,1l0,13.6c0,0.9,0.2,1.1,0.5,1.6 c0.4,0.6,0.8,1,1.3,1.4c1.7,1,11.8,6.8,14.7,8.3L5.6,18L4.9,17.6z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.2,29.4L14,28c-0.4-0.2-0.8-0.1-0.6,0.3V32c0.1,0.1,0.3,0.6,0.2,0.8c-0.3,0,1.3,1.3,2.2,1.8 c0.3,0.1,0.8,0.2,0.7-0.4v-4.4c0-0.1,0-0.2-0.1-0.3C16.4,29.5,16.3,29.4,16.2,29.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.1,29.6c-0.3-0.4-1.5-1.1-2.3-1.7c-0.2-0.1-0.5,0-0.5,0.2c0.1,2.8,0.1,4.1,0.2,4.6c0.1,0.4,1.4,1.3,2.2,1.8 c0.2,0.2,0.5,0.2,0.5-0.1c0-1.2,0-3.9,0-4.6C16.2,29.8,16.2,29.7,16.1,29.6L16.1,29.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M26.5,21.2c0,4.2,3.2,7.2,7.2,7.2c3,0,5.5-1.5,6.6-4.2h-2.8c-0.8,1.5-2.1,2.2-3.8,2.2c-2.8,0-4.8-2-4.8-5.2 c0-3.2,2-5.2,4.8-5.2c1.7,0,3,0.7,3.8,2.2h2.8c-1.1-2.8-3.6-4.2-6.6-4.2C29.7,14.1,26.5,17,26.5,21.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53.1,22.7c0-3.5-2.5-5.8-5.7-5.8c-3.2,0-5.7,2.2-5.7,5.8c0,3.5,2.4,5.8,5.6,5.8 C50.5,28.5,53.1,26.2,53.1,22.7z M44,22.7c0-2.5,1.6-3.7,3.3-3.7c1.7,0,3.4,1.2,3.4,3.7c0,2.5-1.7,3.8-3.4,3.8 C45.5,26.5,44,25.3,44,22.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M54.8,28.3h2.3V17.2h-2.3V28.3z M56,15.7c0.8,0,1.5-0.6,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.6-1.5,1.5 C54.5,15,55.1,15.7,56,15.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.5,28.3h2.3v-6.6c0-3.1-2-4.8-4.6-4.8c-1.3,0-2.6,0.5-3.3,1.5v-1.3h-2.3v11.2h2.3v-6.2c0-2,1.1-3.1,2.8-3.1 c1.7,0,2.8,1.1,2.8,3.1V28.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M74.5,20.7v-4.6h2.6c1.8,0,2.6,0.9,2.6,2.3c0,1.4-0.8,2.3-2.6,2.3H74.5z M82.1,18.4c0-2.3-1.7-4.2-5-4.2h-4.9 v14.1h2.3v-5.7h2.6C80.7,22.6,82.1,20.4,82.1,18.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M82.9,22.7c0,3.4,2.3,5.8,5.3,5.8c1.9,0,3.2-0.9,3.9-1.8v1.7h2.3V17.2h-2.3v1.6c-0.7-0.9-2-1.8-3.9-1.8 C85.2,17,82.9,19.2,82.9,22.7z M92.1,22.7c0,2.4-1.7,3.8-3.4,3.8c-1.7,0-3.4-1.4-3.4-3.8c0-2.4,1.7-3.7,3.4-3.7 C90.4,19,92.1,20.3,92.1,22.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M101.3,25.7l-3.2-8.5h-2.6l4.4,11l-2.3,5.4h2.4l6.9-16.4h-2.4L101.3,25.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124,28.3h2.3v-6.6c0-3.1-2-4.8-4.6-4.8c-1.6,0-3.2,0.9-3.9,2.2c-0.8-1.5-2.3-2.2-4-2.2 c-1.3,0-2.6,0.5-3.3,1.5v-1.3h-2.3v11.2h2.3v-6.2c0-2,1.1-3.1,2.8-3.1c1.7,0,2.8,1.1,2.8,3.1v6.2h2.3v-6.2c0-2,1.1-3.1,2.8-3.1 c1.7,0,2.8,1.1,2.8,3.1V28.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.4,18.9c1.7,0,3.1,1.1,3.1,2.8h-6.2C130.6,20,131.8,18.9,133.4,18.9z M138.7,25h-2.5 c-0.4,0.9-1.2,1.6-2.6,1.6c-1.7,0-3-1.1-3.2-3h8.6c0.1-0.4,0.1-0.7,0.1-1.1c0-3.3-2.3-5.5-5.5-5.5c-3.3,0-5.6,2.2-5.6,5.8 c0,3.5,2.4,5.8,5.6,5.8C136.3,28.5,138,26.9,138.7,25z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M148.6,28.3h2.3v-6.6c0-3.1-2-4.8-4.6-4.8c-1.3,0-2.6,0.5-3.3,1.5v-1.3h-2.3v11.2h2.3v-6.2 c0-2,1.1-3.1,2.8-3.1c1.7,0,2.8,1.1,2.8,3.1V28.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M153.6,25.2c0,2.3,1.2,3.1,3.2,3.1h1.8v-1.9h-1.4c-1,0-1.3-0.3-1.3-1.2V19h2.7v-1.9H156v-2.8h-2.3v2.8h-1.3V19 h1.3V25.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M168.6,25.2c-0.1-4-6.5-2.8-6.5-5c0-0.7,0.7-1.3,1.9-1.3c1.3,0,2,0.7,2.1,1.6h2.3c-0.1-2.2-1.8-3.6-4.3-3.6 c-2.6,0-4.3,1.4-4.3,3.2c0,4.1,6.5,2.8,6.5,5c0,0.8-0.7,1.3-2.1,1.3c-1.3,0-2.2-0.7-2.2-1.7h-2.4c0.1,2,2,3.6,4.7,3.6 C166.9,28.5,168.6,27.1,168.6,25.2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinPaymentsLogoWhiteText);
export default __webpack_public_path__ + "static/media/CoinPayments Logo White Text.6d4ea280d0d5cd05fdc910866d06aa89.svg";
export { ForwardRef as ReactComponent };